import * as Lottie from './lottie';

export { Lottie };
export const LottieAnimation = Lottie.Component.LottieAnimation;
